import React from 'react';
import './style.scss';

/**
 * AvatarDescription - Avatar component with title and subtitle.
 * 
 * @param {Object} props - Props for the AvatarDescription component.
 * @param {string} props.mainText - Main text (title) content.
 * @param {Array<Object>} props.subText - Subtext content.
 * @param {string} props.name - Collaborator's name.
 * @param {string} props.mainTextTranslation - Main text with EN/PT translation.
 * @param {string} props.mainTextAriaLabel - Main text for aria-label.
 * @returns {JSX.Element} The AvatarDescription component.
 * @example
 * <AvatarDescription
		mainText={'Title'}
		name={'Collaborator's name}
		mainTextAriaLabel={'Subtitle'}
		mainTextTranslation={'Main text label in EN/PT'}
		subText={[
				{description: 'description 1', value: 'value 1'}, 
				{description: 'description 2', value: 'value 2'}
			]}
	/>
 */
function AvatarDescription({ mainText, subText, name, mainTextAriaLabel, mainTextTranslation }) {
	return (
		<div className='name-container'>
			<span className='title' aria-label={`${mainTextTranslation} ${mainTextAriaLabel}`}>{mainText}</span>
			{subText.map((item, key) => {
				return (
					<span key={key} className='subtitle'>
						{item.description}: {item.value}
					</span>
				);
			})}
		</div>
	);
};

AvatarDescription.defaultProps = {
    mainText: '',
	subText: [],
	name: '',
	mainTextAriaLabel: '',
	mainTextTranslation: '',
};


export default AvatarDescription;
